import { registerBlockType } from '@wordpress/blocks';
import metadata from './block.json';
import Edit from './Edit';
import Save from './save';

registerBlockType( metadata.name, {
	edit: Edit,
	save: Save,
	icon: {
		foreground: '#0061FE',
		src: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				width="24"
				height="24"
			>
				<path d="M3.5 3h17C21.3 3 22 3.7 22 4.5v15c0 .8-.7 1.5-1.5 1.5h-17C2.7 21 2 20.3 2 19.5v-15C2 3.7 2.7 3 3.5 3Zm0 1.5v15h17v-15h-17Z" />
				<path
					d="M12 3v18"
					stroke="currentColor"
					strokeWidth="1.5"
					fill="none"
				/>
				<path d="M6 8h3v2H6zM15 8h3v2h-3z" opacity=".5" />
			</svg>
		),
	},
} );
